import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countQuantityBomTable',
    standalone: false
})
export class CountQuantityBomTablePipe implements PipeTransform {

  transform(quantity: number, apartments: number[]): number {
    if (apartments.length > 0) {
      return quantity * apartments.length;
    } else {
      return quantity;
    }
  }

}
